import { FC } from 'react';
import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';
import FeatureUnavailableNotice from './FeatureUnavailableNotice';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const FeatureUnavailableDialog: FC<Props> = ({ open, onClose }) => {
  const lang = useLanguage()[0].FeatureUnavailableNotice;

  return open ? (
    <Dialog open onClose={onClose} title={lang.title} body={<FeatureUnavailableNotice onUpgradeRequest={onClose} />} />
  ) : null;
};

export default FeatureUnavailableDialog;
